module.exports = __webpack_public_path__ + "img/icon4.72639a96.png";